export function thousandsComma(value: string | number) {
  const intValue = typeof value === 'string' ? parseInt(value, 10) : value;

  if (Number.isNaN(intValue) || intValue < 1000) {
    return value;
  }

  const valueString = value.toString();
  const decimalSplit = valueString.split('.');
  const integer = decimalSplit[0];
  const decimal = decimalSplit[1] ? `.${decimalSplit[1]}` : '';

  const lastThreeDigits = integer.length - 3;

  const thousandsComma = `${integer.substring(0, lastThreeDigits)},${integer.substring(lastThreeDigits)}`;

  return thousandsComma + decimal;
}

export function friendlyDuration(seconds: number): [number, string] {
  let unit;
  let value;
  switch (true) {
    case seconds > 3600:
      value = Math.ceil(seconds / 60 / 60);
      unit = 'hour';
      break;
    case seconds > 60:
      value = Math.ceil(seconds / 60);
      unit = 'min';
      break;
    default:
      value = seconds;
      unit = 'sec';
  }

  if (value !== 1) {
    unit = `${unit}s`;
  }

  return [value, unit];
}

export function useFormat() {
  return {
    friendlyDuration,
    thousandsComma,
  };
}
